import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import Image from '@/app/components/Image';

export interface CardQuoteProps {
  readonly affiliation: string;
  readonly avatarUrl: string;
  readonly name: string;
  readonly quote: MessageKey;
}

const CardQuote = ({ affiliation, avatarUrl, name, quote }: CardQuoteProps) => {
  const t = useTranslations();

  return (
    <div className="p-12">
      <TypographyV3 Element="q" className="mb-8 text-lg">
        {t(quote)}
      </TypographyV3>
      <div className="mt-8 flex items-center">
        <Image
          src={avatarUrl}
          alt={`Avatar for ${name}`}
          className="mr-4 rounded-full"
          width={40}
          height={40}
        />
        <div>
          <TypographyV3 variant="body-small" weight="bold">
            {name}
          </TypographyV3>
          <TypographyV3 variant="eyebrow-small" weight="light">
            {affiliation}
          </TypographyV3>
        </div>
      </div>
    </div>
  );
};

export default CardQuote;
